import React from 'react';
import DataTable from "../../../DataTable";
import Spinner from "../../../Spinner";
import {inject, observer} from "mobx-react/index";
import {Link} from "react-router";

@inject('ticketStore', 'workOrderStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore', 'userStore', 'inventoryItemStore')
@observer
export default class StationWorkOrderList extends React.Component {
  slug = `station/${this.props.params.id}/maintenance/work_order`;
  actionColumn = [
    {key: 'title', label: 'Title'},
    {key: 'ticket', label: 'Ticket'},
    {key: 'status', label: 'Status'},
    {key: 'priority', label: 'Priority'},
    {key: 'maintenance_type', label: 'Maintenance Type'},
    {key: 'creation_date', label: 'Creation Date'},
    {key: 'scheduled_date', label: 'Scheduled Date'},
    {key: 'completion_deadline', label: 'Completion Deadline'},
    {key: 'created_by', label: 'Created By'},
    {key: 'assigned_to', label: 'Assigned To'},
  ];

  componentWillMount() {
    const {workOrderStore, inventoryItemStore} = this.props;
    workOrderStore.items.length === 0 && workOrderStore.fetchItems();
    inventoryItemStore.items.length === 0 && inventoryItemStore.fetchItems();
  }

  render() {
    const {ticketStore, workOrderStore, workOrderStatusStore, priorityStore, maintenanceTypeStore, userStore, inventoryItemStore, params: {id}, workOrderView, view_archived} = this.props;

    if (workOrderView) return React.cloneElement(workOrderView, {view_archived});

    let items = workOrderStore.items.filter(workOrder => workOrder.station && workOrder.station.find(s => +s.id === +id)).filter(item => view_archived ? true : !item.archived).map(item => {
      let priority = priorityStore.findById(item.priority_id),
        maintenance_type = maintenanceTypeStore.findById(item.maintenance_type),
        created_by = userStore.findById(item.created_by),
        assigned_to = userStore.findById(item.assigned_to),
        status = workOrderStatusStore.findById(item.status_id);

      return {
        id: item.id,
        // title: <Link to={`/station/${id}/maintenance/work_order/${item.id}/view`}>{item.title || 'View'}</Link>,
        title: <div>
          <Link to={`/station/${id}/maintenance/work_order/${item.id}/view`}>{item.title || 'View'}</Link>{' '}
          {item.archived && <div className='chip' data-toggle='tooltip' title='Archived'>A</div>}
        </div>,
        ticket: item.ticket && <ul>{item.ticket.map(t => 
          <li key={`work_order-${item.id}-station-${t.id}`}><Link to={`/station/${id}/maintenance/ticket/${t.id}/view`}>{t.summary || 'View'}</Link>{' '}
          {t.archived && <div className='chip' data-toggle='tooltip' title='Archived'>A</div>}
        </li>)}</ul>,
        priority: priority && priority.caption,
        maintenance_type: maintenance_type && maintenance_type.caption,
        completion_deadline: item.completion_deadline,
        scheduled_date: item.scheduled_date,
        creation_date: item.creation_date,
        created_by: created_by && created_by.name,
        assigned_to: assigned_to && assigned_to.name,
        status: status && status.caption
      }
    });
    return (
      <div>
        <DataTable data={items} slug={this.slug} columns={this.actionColumn} actions={this.actions} resource='maintenance' allowAdd allowEdit allowDelete/>
        {(workOrderStore.isLoading || workOrderStatusStore.isLoading || priorityStore.isLoading || maintenanceTypeStore.isLoading || userStore.isLoading || inventoryItemStore.isLoading) && <Spinner/>}
        {this.props.children ? React.cloneElement(this.props.children, {slug: this.slug, station_id: id, view_archived}) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Station/Maintenance/WorkOrder/StationWorkOrderList.js